export default __webpack_public_path__ + "static/media/calculation.65365244.svg";